import React, {useState} from 'react';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import {Actions as ACTIONS} from '../../store/actions/payslipActions';
import { format } from 'date-fns'
import { InboxArrowDownIcon } from "@/icons/outline";

import Spinner from '../common/Spinner';
import { XMarkIcon } from '@heroicons/react/20/solid'

import cleanDeep from "clean-deep";

const SendPayslipsModal = ({
  salary,
  sendPayslips,
  closeModal,
  modalStatus,
  payslipCount,
  sending,
  sent
}) => {
  const [attachPdf, setAttachPdf] = useState(false);

  const { register, handleSubmit, control, watch, setValue, reset } = useForm();

  if (!modalStatus){
    return null
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{display: "block",background: "rgba(0,0,0,0.4)",overflow:"scroll"}}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b" style={{padding: 0}}>
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button data-dismiss="modal" type="button" onClick={closeModal}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title" style={{padding:"15px 20px"}}>
                Send {payslipCount} Payslips by Email
              </h3>
            </div>
            <div className="modal-body span-alert">
              <div className="clearfix"></div>
              Once you send your payslips, employees will recieve an email to open their payslips online.
            </div>
            <div className="block-content" style={{padding: "20px 20px 1px"}}>
              <label className="css-input switch switch-sm switch-default">
                <input type="checkbox"
                  checked={attachPdf}
                  onChange={(e => setAttachPdf(e.target.checked))}
                />
                  <span></span>
                  <label htmlFor="material-text">Include PDF Attachment</label>
              </label>

              { attachPdf && 
                <div className="alert alert-danger">
                  <div className="clearfix"></div>
                  <p>By including the PDF as an email attachment, you agree to take full responsability should the email content be intercepted.
                  Emails when read by employees may have content transferred over unsecure channels.</p>

                  <p>We highly recommend that users login to their account to view payslips instead of having them attached in an email.</p>
                </div>
              }


              {
                  sending && 
                  <Spinner 
                     style={{width: '2rem',height: '2rem', verticalAlign: 'middle',marginTop: 20}}
                     className="animate-spin -ml-1 mr-3 h-5 w-5 text-success right"/>
              }

              <div className="block buttons">
                {
                  !sent && 
                  <button className="btn btn-success pull-right" type="submit"
                    onClick={() => sendPayslips({
                      attachPdf
                    })}
                  >
                    <InboxArrowDownIcon className="w-7 h-7 mr-3" style={{verticalAlign: "text-bottom"}}/>
                    Send {payslipCount} Payslips
                  </button>
                }
                {
                  sent && 
                  <div className="btn btn-success pull-right">
                    Payslips sent successfully
                  </div>
                }
                <div className="clearfix"></div>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {

  const { employees } = state.payroll;
  const {sendPayslipModal} = state

  return {
    payslipCount: employees && employees.length,
    modalStatus: sendPayslipModal && sendPayslipModal.status,
    sending: sendPayslipModal && sendPayslipModal.sending,
    sent: sendPayslipModal && sendPayslipModal.sent,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(ACTIONS.sendPayslipsModal(false)),
  sendPayslips: (options) => dispatch(ACTIONS.sendPayslips(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SendPayslipsModal);
